import { Controller } from "@hotwired/stimulus"
import { setHidden } from "../lib/display_toggle"

// Live-filters a list of `item` targets by title + body text. Used on the
// agent-facing Support Dashboard accordion (items are `.gl-accordion-item`s
// with a `.gl-accordion-header[data-question]` + `.gl-accordion-body`) AND
// on the Support Admin manage table (items are plain `%tr` rows carrying
// `data-question` directly, with neither child selector present) — the
// lookups below are null-safe so either shape works without a second
// controller.
export default class extends Controller {
  static targets = ["input", "item"]

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach((item) => {
      if (query === "") {
        setHidden(item, false)
        return
      }
      const header = item.querySelector(".gl-accordion-header")
      const title = header ? (header.getAttribute("data-question") || header.textContent) : (item.getAttribute("data-question") || "")
      const bodyEl = item.querySelector(".gl-accordion-body")
      const body = bodyEl ? bodyEl.textContent : item.textContent
      const matches = title.toLowerCase().includes(query) || body.toLowerCase().includes(query)
      // Class toggle, not inline display — a row carrying a display utility
      // would otherwise never hide (#12284; see lib/display_toggle.js).
      setHidden(item, !matches)
    })
  }
}
